import { useCallback, useState } from "react"
import { TimelineResourceLabelContent } from "../calendar/fullCalendarTypes"
import { useResourceLabelSharedContext } from "../context/ResourceLabelContext"
import { ResourceCalendarLabelContent } from "./ResourceCalendarLabelContent"

export type ResourceLabelProps = Readonly<{
    resource: TimelineResourceLabelContent["resource"]
}>

export function ResourceLabel({ resource }: ResourceLabelProps) {
    const [isSelectionPending, setIsSelectionPending] = useState(false)

    const {
        loadingServiceCenterIds,
        isLocked,
        selectedResourceIdsSet,
        eventsLoadingNativeTitle,
        searchRegex,
        toggleResourceSelection: executeToggle,
        handleOpenDetails,
    } = useResourceLabelSharedContext()

    const serviceCenterId = resource.extendedProps.locationId.split("_")[0]
    const isEventsLoading = loadingServiceCenterIds.has(serviceCenterId)

    const isChecked = selectedResourceIdsSet.has(resource.id)

    const toggleResourceSelection = useCallback(
        async (resourceId: string) => {
            if (isEventsLoading) return
            setIsSelectionPending(true)
            try {
                await executeToggle(resourceId)
            } finally {
                setIsSelectionPending(false)
            }
        },
        [isEventsLoading, executeToggle],
    )

    return (
        <ResourceCalendarLabelContent
            isChecked={isChecked}
            resource={resource}
            searchRegex={searchRegex}
            toggleResourceSelection={toggleResourceSelection}
            handleOpenDetails={handleOpenDetails}
            isLocked={isLocked}
            isEventsLoading={isEventsLoading}
            isSelectionPending={isSelectionPending}
            eventsLoadingNativeTitle={eventsLoadingNativeTitle}
        />
    )
}
